module.exports = __webpack_public_path__ + "assets/dd333a9d9c4dd07f4832d83486703de2.offers-image.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/offers-image.png
 ** module id = 840
 ** module chunks = 1
 **/